import React from 'react';
import { appAssets } from 'constants/assets';
import './filteringDatePicker.css';
import { getDateByPeriodByType, getDateRangeLabel } from 'helpers/getTimePeriod';

export interface FilteringDatePickerProps {
  inputTitle: string;
  handleOpenMoldal: any;
  dateSelection: any;
  currentSelection: any;
}

const CalendarIcon = appAssets.icons.CALENDAR_FILTER_DRAWER;

const currentDate = new Date();
const monthToDateStart = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);

const FilteringDatePicker: React.FC<FilteringDatePickerProps> = ({
  inputTitle,
  handleOpenMoldal,
  dateSelection,
  currentSelection,
}) => {
  dateSelection =
    Object.keys(dateSelection).length !== 0 ? dateSelection : currentSelection.dateFilter;
  const dateFilterType = currentSelection?.dateFilter?.type;
  const startDateLabel = dateSelection?.startDate;
  const endDateLabel = dateSelection?.endDate;

  return (
    <div className="diy-input-container">
      <div className="diy-date-range-container diy-calendar-input">
        <div style={{ display: 'flex', paddingRight: '10px' }}>
          {currentSelection.dateFilter && dateFilterType !== 'CustomRange' ? (
            <>
              <label>{getDateRangeLabel(currentSelection.dateFilter)}</label>
            </>
          ) : (
            <>
              <label>
                {dateSelection ? startDateLabel : monthToDateStart.toLocaleDateString()}{' '}
              </label>{' '}
              - <label>{dateSelection ? endDateLabel : currentDate.toLocaleDateString()}</label>
            </>
          )}
        </div>
        <div className="diy-icon-container">
          <div className="diy-filtering-vertical-line"></div>
          <CalendarIcon className="diy-filtering-icon" onClick={handleOpenMoldal}></CalendarIcon>
        </div>
      </div>
      <div className="diy-label">{inputTitle}</div>
    </div>
  );
};

export default FilteringDatePicker;
